module.exports = __webpack_public_path__ + "static/img/la.0f124ae3.svg";